import api from '../services/api';
import { IGuideLogs } from '../shared/interfaces';

export const getGuideLogs = async (
  id: string | undefined,
): Promise<IGuideLogs[]> => {
  if (!id) {
    throw new Error('ID da guia não fornecido.');
  }
  const response = await api.get(`/guides-logs/list/${id}`);
  return response.data;
};
